import { render } from "./ModalInformativoDisclaimer.vue?vue&type=template&id=b1a2b1c8&scoped=true"
import script from "./ModalInformativoDisclaimer.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDisclaimer.vue?vue&type=script&lang=js"

import "./ModalInformativoDisclaimer.vue?vue&type=style&index=0&id=b1a2b1c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a2b1c8"]])

export default __exports__